import Vue from 'vue';

var options = {
  persist: true,
};
Vue.use(options);
// store/modules/navigation.js
const state = {
  navigationList: [], // [{ tab: Window, href: String }]
};
const mutations = {
  ADD_TAB(state, { tab, href }) {
    state.navigationList.push({ tab, href });
  },
  SET_LIST(state, list) {
    state.navigationList = list;
  },
};
const actions = {
  gotoBlankPage({ commit, dispatch }, href) {
    const blankPage = window.open(href, '_blank');
    commit('ADD_TAB', { tab: blankPage, href });
    dispatch('removeDuplicateTabs');
  },
  focusBlankPage({ state, dispatch }, routeHref) {
    // Clean up any undefined/null entries
    const cleanedList = state.navigationList.filter((item) => item && item.tab);
    const existingTab = cleanedList.find(({ href }) => routeHref === href)?.tab;
    if (existingTab && !existingTab.closed) {
      existingTab.focus();
    } else {
      dispatch('gotoBlankPage', routeHref);
    }
  },
  removeDuplicateTabs({ state, commit }) {
    const uniqueList = [];
    const seen = new Set();
    state.navigationList?.reverse().forEach((item) => {
      if (!seen.has(item.href)) {
        uniqueList.push(item);
        seen.add(item.href);
      }
    });
    commit('SET_LIST', uniqueList);
  },
  closeTabByHref({ state, commit }, href) {
    const tabIndex = state.navigationList.findIndex(item => item.href === href);

    if (tabIndex === -1) {
      return;
    }

    const tab = state.navigationList[tabIndex];

    if (tab?.tab && !tab.tab.closed) {
      tab.tab.close();
    }

    const updatedList = state.navigationList.filter(item => item.href !== href);
    commit('SET_LIST', updatedList);
  }
};
export default {
  mutations,
  state,
  actions,
};
